<template>
    <!-- eslint-disable-next-line vuejs-accessibility/click-events-have-key-events vuejs-accessibility/no-static-element-interactions -->
    <dialog
        :id="modalId"
        class="modal"
        @click.self="closeModal"
        @keydown.esc="closeModal"
    >
        <div class="modal-box max-w-xl max-h-[90vh] flex flex-col">
            <button
                type="button"
                class="btn btn-sm btn-circle absolute top-4 right-4 z-10"
                @click="closeModal"
            >
                <MiscIcon name="x" />
                <span class="sr-only">{{ $t('product.detail.warrantyModal.close') }}</span>
            </button>

            <div class="flex flex-col gap-6 overflow-y-auto">
                <img
                    src="/images/a4g_2026_gewaehrleistungslabel.png"
                    alt="EU Garantielabel"
                    class="w-full h-auto object-contain"
                >
                <MiscLink
                    :to="$t('layout.footerNavigation.warrantyLink')"
                    external
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    class="flex link link-primary items-center justify-start text-sm gap-[6px] py-1 px-3"
                >
                    {{ $t('product.detail.tabs.warrantyConditionsLink') }}
                    <MiscIcon name="arrow-right" size="xs" class="!w-4 !h-4" />
                </MiscLink>
            </div>
        </div>
        <form method="dialog" class="modal-backdrop">
            <button type="button" @click="closeModal">close</button>
        </form>
    </dialog>
</template>

<script setup lang="ts">
interface Props {
    modalId: string
}

const props = defineProps<Props>()

function closeModal() {
    const modal = document.getElementById(props.modalId) as HTMLDialogElement
    modal?.close()
}
</script>
